import EINA_01_REGULAR from '../../../assets/fonts/eina-01/Eina01_Regular.otf'
import EINA_01_REGULAR_ITALIC from '../../../assets/fonts/eina-01/Eina01_RegularItalic.otf'
import EINA_01_SEMIBOLD from '../../../assets/fonts/eina-01/Eina01_SemiBold.otf'
import EINA_01_BOLD from '../../../assets/fonts/eina-01/Eina01_Bold.otf'

export const EINA_01_FONT = `
  @font-face {
    font-family: 'Eina 01';
    font-style: normal;
    font-weight: 400;
    src: url(${EINA_01_REGULAR}) format('opentype');
  }

  @font-face {
    font-family: 'Eina 01';
    font-style: italic;
    font-weight: 400;
    src: url(${EINA_01_REGULAR_ITALIC}) format('opentype');
  }

  @font-face {
    font-family: 'Eina 01';
    font-style: normal;
    font-weight: 600;
    src: url(${EINA_01_SEMIBOLD}) format('opentype');
  }

  @font-face {
    font-family: 'Eina 01';
    font-style: normal;
    font-weight: 700;
    src: url(${EINA_01_BOLD}) format('opentype');
  }
`
